import { use_slice_ui } from '@/hooks/store/use_slices';
import { FIELD__list_lora } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_lora';
import { FIELD__ml_asset_lora } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD__ml_asset_lora';
import { FIELD_GRID2D_MODE__all_loras_except_one } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__all_loras_except_one';
import { FIELD_GRID2D_MODE__lora_after_lora } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__lora_after_lora';
import { FIELD_GRID2D_MODE__lora_vs_lora } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__lora_vs_lora';
import { FIELD_GRID2D_MODE__single_lora_generation } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__single_lora_generation';
import { G_HOOK__output__field_hovered_set } from '../_base/_hooks/G_HOOK__output__field_hovered_set';
import { G_UI_FIELD__header } from '../_base/G_UI_FIELD__header';
import { G_BUTTON__ml_asset_lora_list__select_all } from './_buttons/G_BUTTON__ml_asset_lora_list__select_all';
import { G_UI_FIELD__ml_asset_lora_list_item } from './G_UI_FIELD__ml_asset_lora_list_item';

interface PROPS {
  field: FIELD__list_lora;
}

export function G_UI_FIELD__ml_asset_lora_list({ field }: PROPS) {
  /*
   *
   */

  const { g_hovered_grid2d_row, g_hovered_grid2d_column, g_hovered_grid2d_dimension_from_grid } = use_slice_ui([
    'g_hovered_grid2d_row',
    'g_hovered_grid2d_column',
    'g_hovered_grid2d_dimension_from_grid',
  ]);
  /*
   *
   */
  const { onMouseOver, onMouseLeave } = G_HOOK__output__field_hovered_set({ field });

  /*
   *
   */

  function get_items() {
    let out = [...field.items];

    if (!g_hovered_grid2d_dimension_from_grid) {
      return out;
    }

    if (g_hovered_grid2d_row instanceof FIELD_GRID2D_MODE__lora_vs_lora) {
      out = field.get_loras_by_hashes(g_hovered_grid2d_row.hashes);
    }
    //
    else if (g_hovered_grid2d_row instanceof FIELD_GRID2D_MODE__lora_after_lora) {
      out = field.get_loras_by_hashes(g_hovered_grid2d_row.hashes);
    } else if (g_hovered_grid2d_column instanceof FIELD_GRID2D_MODE__lora_after_lora) {
      out = field.get_loras_by_hashes(g_hovered_grid2d_column.hashes);
    }
    //
    else if (g_hovered_grid2d_column instanceof FIELD_GRID2D_MODE__single_lora_generation) {
      out = field.get_loras_by_hashes([g_hovered_grid2d_column.hash_selected]);
    } else if (g_hovered_grid2d_row instanceof FIELD_GRID2D_MODE__single_lora_generation) {
      out = field.get_loras_by_hashes([g_hovered_grid2d_row.hash_selected]);
    }
    //
    else if (g_hovered_grid2d_column instanceof FIELD_GRID2D_MODE__all_loras_except_one) {
      out = field.get_loras_by_hashes__except([g_hovered_grid2d_column.hash_selected]);
    } else if (g_hovered_grid2d_row instanceof FIELD_GRID2D_MODE__all_loras_except_one) {
      out = field.get_loras_by_hashes__except([g_hovered_grid2d_row.hash_selected]);
    }

    return out;
  }

  /*
   *
   */

  function render_item(field: FIELD__ml_asset_lora) {
    return <G_UI_FIELD__ml_asset_lora_list_item {...{ field }} key={field.meta.field_id} />;
  }

  /*
   *
   */

  let items = get_items();

  return (
    <div className="flex flex-col w-full" {...{ onMouseOver, onMouseLeave }}>
      <G_UI_FIELD__header {...{ field }}>
        <G_BUTTON__ml_asset_lora_list__select_all {...{ field }} />
      </G_UI_FIELD__header>
      {items.map(render_item)}
    </div>
  );
}
